module.exports = __webpack_public_path__ + "static/media/Privacy Notice and Consent_ERITOPASP.docx.3d27f3f3.pdf";